import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=73db9726"
import script from "@/views/Users/Student/Profile.ts?vue&type=script&lang=ts&external"
export * from "@/views/Users/Student/Profile.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Users/Student/profile.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports